import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'

const createReducer = () => {
    const initialState = {
        columnsOrder: [],
        columnsSelected: {},
        isSummaryRowShown: false,
    }

    return handleActions({
        [ActionTypes.ORDER_SET]: (state, {payload: columnsOrder}) => ({
            ...state,
            columnsOrder: columnsOrder,
        }),
        [ActionTypes.SELECTED_SET]: (state, {payload: columnsShown}) => ({
            ...state,
            columnsSelected: columnsShown,
        }),
        [ActionTypes.IS_SUMMARY_ROW_SHOWN_SET]: (state, {payload: isSummaryRowShown}) => ({
            ...state,
            isSummaryRowShown: isSummaryRowShown
        }),
    }, initialState)
}

export default createReducer



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/configurationMenu/reducer.js